/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoSearchSortBy } from './videoSearchSortBy';


export interface VideoSearchQuery { 
    search_query?: string | null;
    title?: string | null;
    description?: string | null;
    date_start?: string | null;
    date_end?: string | null;
    duration_min?: number | null;
    duration_max?: number | null;
    status?: Array<VideoSearchQuery.StatusEnum> | null;
    gender?: Array<VideoSearchQuery.GenderEnum> | null;
    category_ids?: Array<number> | null;
    competition_ids?: Array<number> | null;
    sort_by?: Array<VideoSearchSortBy> | null;
    page?: number;
    page_size?: number;
}
export namespace VideoSearchQuery {
    export const StatusEnum = {
        Pending: 'PENDING',
        Uploading: 'UPLOADING',
        Processing: 'PROCESSING',
        Ready: 'READY',
        Failed: 'FAILED',
        Deleted: 'DELETED',
        Archived: 'ARCHIVED',
        Retired: 'RETIRED',
        YoutubePending: 'YOUTUBE_PENDING',
        OnlyData: 'ONLY_DATA'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const GenderEnum = {
        Femenino: 'FEMENINO',
        Masculino: 'MASCULINO',
        Mixto: 'MIXTO',
        NoEspecificado: 'NO ESPECIFICADO'
    } as const;
    export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];
}


